import React from 'react';
import Card from "../../../base/components/Card/Card";
import { withSitecoreCustomContext } from "../../hooks/withSitecoreCustomContext";
var PageEditorWrapper = function PageEditorWrapper(WrappedComponent) {
  return function (props) {
    var _props$rendering;
    if (!props.fields && !(props !== null && props !== void 0 && (_props$rendering = props.rendering) !== null && _props$rendering !== void 0 && _props$rendering.placeholders)) {
      var _props$sitecoreContex;
      if (props !== null && props !== void 0 && (_props$sitecoreContex = props.sitecoreContext) !== null && _props$sitecoreContex !== void 0 && _props$sitecoreContex.pageEditing) {
        return /*#__PURE__*/React.createElement("div", {
          className: "sheet section py-4"
        }, /*#__PURE__*/React.createElement(Card, {
          className: "content-widget-icon mx-auto py-3 px-1",
          style: {
            borderColor: 'red',
            background: '#ffa3a3'
          }
        }, /*#__PURE__*/React.createElement("h2", {
          className: "text-title m-0 content-widget-icon__text text-center"
        }, "Datasource is not set"), /*#__PURE__*/React.createElement("h3", {
          className: "text-title m-0 content-widget-icon__text text-center"
        }, "Please add a datasource to make the component be shown.")));
      }
      return null;
    }
    return /*#__PURE__*/React.createElement(WrappedComponent, props);
  };
};
export default (function (WrappedComponent) {
  return withSitecoreCustomContext()(PageEditorWrapper(WrappedComponent));
});